import DataTable, { TableColumn } from 'react-data-table-component';

import FlexContainer from 'global_elements/Layouts/FlexContainer';
import InlineText from 'global_elements/Text/InlineText';
import { ReactComponent as SortIcon } from 'icons/mho-sort-icon-white.svg';
import { JSX } from 'react';

import { EventsListDataRow, EventsListTableProps } from 'types/tableProps';
import { AlignVariant, DisplayVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';
import { FontColors, FontSizes } from 'global_elements/Text/variants';

import MHODateTime from 'domain/dateTime/MHODateTime';
import { AlternatingBasicTableStyle } from '../styles';

const NoDataComponent: JSX.Element = <InlineText text="No events reported." fontColor={FontColors.PRIMARY} fontSize={FontSizes.LARGE} />;

const columns: TableColumn<EventsListDataRow>[] = [
  {
    name: <div>Name</div>,
    selector: (row) => row.name,
    sortable: true,
  },
  {
    name: <div>Patient Acct No.</div>,
    selector: (row) => row.patientAccountNumber,
    sortable: true,
  },
  {
    name: <div>Start Date</div>,
    selector: (row) => row.eventStartDate,
    sortable: true,
    format: (row) => (new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/).test(row.eventStartDate) ? new MHODateTime(row.eventStartDate).getFormattedCalendarDate() : row.eventStartDate),
  },
  {
    name: <div>Stop Date</div>,
    selector: (row) => row.eventStopDate,
    sortable: true,
    format: (row) => (new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/).test(row.eventStopDate) ? new MHODateTime(row.eventStopDate).getFormattedCalendarDate() : row.eventStopDate),
  },
  {
    name: <div>Start Time</div>,
    selector: (row) => row.eventStartTime,
    sortable: true,
  },
  {
    name: <div>Start Time UTD</div>,
    selector: (row) => row.eventStartTimeUTD,
    sortable: true,
  },
  {
    name: <div>Stop Time</div>,
    selector: (row) => row.eventStopTime,
    sortable: true,
  },
  {
    name: <div>Stop Time UTD</div>,
    selector: (row) => row.eventStopTimeUTD,
    sortable: true,
  },
];

const EventsListTable = (props: EventsListTableProps): JSX.Element => (
  <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.CENTER} align={AlignVariant.END} extraClasses="events-list-table">
    <DataTable dense persistTableHead sortIcon={<SortIcon />} customStyles={AlternatingBasicTableStyle} columns={columns} data={props.data} noDataComponent={NoDataComponent} />
  </FlexContainer>
);

export default EventsListTable;
